import React from 'react'
import { StyleSheet, View } from 'react-native'
import Modal from 'react-native-modal'
import { useTheme } from '@react-navigation/native'
import type { Theme } from '@theme'
import { useLanguage } from '@context'
import { Text } from '../../../../components/atoms/text/Text'
import { CreatePasswordForm } from '../../../../components/organisms/CreatePasswordForm'

interface CreatePasswordModalProps {
  isVisible: boolean
  onClose: () => void
}

/** "Créer mon mot de passe": same form as after an event sign-up, in a modal. */
export const CreatePasswordModal: React.FC<CreatePasswordModalProps> = ({ isVisible, onClose }) => {
  const theme = useTheme()
  const styles = getStyles(theme)
  const { t } = useLanguage()

  return (
    <Modal
      isVisible={isVisible}
      onBackdropPress={onClose}
      onBackButtonPress={onClose}
      animationIn="fadeIn"
      animationOut="fadeOut"
      statusBarTranslucent
      avoidKeyboard
      style={styles.modal}
    >
      <View style={styles.container}>
        <Text type="bodyBold" style={styles.title}>
          {t('createPassword.title')}
        </Text>
        <Text type="bodySmall" style={styles.message}>
          {t('createPassword.subtitle')}
        </Text>
        <CreatePasswordForm onSaved={onClose} onLater={onClose} />
      </View>
    </Modal>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    // No `alignItems: 'center'` here: with `avoidKeyboard` the content sits in a
    // KeyboardAvoidingView that would then shrink to its text's natural width,
    // so the card overflowed the screen and was cut on the left (iOS).
    modal: {
      justifyContent: 'center',
      paddingHorizontal: theme.spacing.lg,
    },
    container: {
      width: '100%',
      maxWidth: 480,
      alignSelf: 'center',
      backgroundColor: theme.colors.white,
      borderRadius: theme.border.medium,
      padding: theme.spacing.xl,
    },
    title: { textAlign: 'center', marginBottom: theme.spacing.md },
    message: { textAlign: 'center', marginBottom: theme.spacing.lg },
  })
